import React from "react";
import styles from "../../assets/styles/AppHome/QuickLinksCard.module.scss";
import { MimaText, MimaToastUtil } from "../../components";
import { MdOutlineContentCopy } from "react-icons/md";

const DashboardLinkCopy = ({ title, link, copyOnly = false }) => {
  if (link)
    return (
      <div className={styles.reference}>
        <div className={styles.reference__link}>
          <MimaText mb={0.5} color="var(--color-white)">
            {title}
          </MimaText>
          <div
            onClick={() => {
              navigator.clipboard.writeText(link);
              MimaToastUtil.success({
                message: `Copied ${title}`,
              });
              if (!copyOnly) {
                window.open(link, "_blank");
              }
            }}
            className={styles.reference__copy}
          >
            <span>{link}</span>
            <MdOutlineContentCopy className={styles.reference__copy__icon} />
          </div>
        </div>
      </div>
    );
};

export default DashboardLinkCopy;
